// Changes the tab title while the visitor is on another tab, alternating between two messages,
// and restores the page title as soon as the tab is visible again.
(() => {
  const script = document.currentScript;
  if (!script) return;

  const messages = [script.getAttribute('data-message-1'), script.getAttribute('data-message-2')].filter(
    (message) => message && message.trim()
  );
  if (!messages.length) return;

  const delay = Math.max(1, Number(script.getAttribute('data-delay')) || 3) * 1000;
  let originalTitle = document.title;
  let timer = null;
  let index = 0;

  const showNextMessage = () => {
    document.title = messages[index % messages.length];
    index += 1;
    if (messages.length > 1) timer = setTimeout(showNextMessage, delay);
  };

  const stop = () => {
    clearTimeout(timer);
    timer = null;
    if (index > 0) document.title = originalTitle;
    index = 0;
  };

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stop();
      originalTitle = document.title;
      timer = setTimeout(showNextMessage, delay);
    } else {
      stop();
    }
  });

  window.addEventListener('pagehide', stop);
})();
